export class ActiveMessagePermission {
    Email: string | null;
    Name: string | null;
    Locale: string | null;
    Reason: any | null;
    PermissionGranted: boolean | null;
    ApplicationIdentity: string | null;

    constructor(
      email?: string, 
      name?: string, 
      locale?: string, 
      reason?: any, 
      permissionGranted?: boolean,
      applicationIdentity?: string) {
      this.Email = email;
      this.Name = name;
      this.Locale = locale;
      this.Reason = reason;
      this.PermissionGranted = permissionGranted;
      this.ApplicationIdentity = applicationIdentity;
    }
}